import { fetchAllManufacturers } from 'api/manufacturers';

import { useQuery } from 'react-query';

/**
 * Manufacturers are a small, rarely-changing reference list shared by every
 * SKU modal, so the result is cached rather than refetched per modal open.
 */
export const useManufacturers = () => {
  const query = useQuery(['fetch-all-manufacturers'], fetchAllManufacturers, {
    staleTime: 5 * 60 * 1000,
  });

  return query;
};
